import { AsyncPipe } from '@angular/common';
import { Component, computed, inject, Input, input, Signal, ViewEncapsulation } from '@angular/core';

import { IconFlags, Icons, IconsColored, IconsSocial, IconType, Illustrations } from './icon-name.enum';

import { SpriteService } from 'app/shared/icon/sprite';

@Component({
    selector: 'stby-icon',
    imports: [AsyncPipe],
    template: `
        @if (spriteService.spriteLoaded$ | async) {
            <svg
                [attr.class]="'icon-' + icon()"
                [attr.width]="width() || size()"
                [attr.height]="size()"
                [attr.fill]="Icons[icon()] ? fill() : 'none'"
                [attr.aria-label]="alt() || icon()"
                [style.transform]="rotate ? 'rotate(' + rotate + 'deg)' : null"
            >
                <use [attr.href]="'#' + iconName()"></use>
            </svg>
        }
    `,
    styleUrl: './icon.scss',
    encapsulation: ViewEncapsulation.None,
})
export class Icon {
    spriteService = inject(SpriteService);

    icon = input<IconType>();

    readonly size = input<string | number>(24);
    readonly width = input<string | number>(null); // Used to set a different width than height (size)
    readonly fill = input<string>('currentColor');
    readonly alt = input<string>('');
    @Input() rotate: string | number = 0;

    Icons = Icons;

    iconName: Signal<string> = computed(() => this.getIconName());

    private getIconName(): string {
        const iconKey = this.icon();
        if (Icons[iconKey]) {
            return 'icons-' + Icons[iconKey];
        } else if (IconsSocial[iconKey]) {
            return 'socials-' + IconsSocial[iconKey];
        } else if (IconsColored[iconKey]) {
            return 'colored-' + IconsColored[iconKey];
        } else if (Illustrations[iconKey]) {
            return 'illustrations-' + Illustrations[iconKey];
        } else if (IconFlags[iconKey]) {
            return 'flags-' + IconFlags[iconKey];
        } else {
            console.warn('Icon ', iconKey, ' not found');
            return '';
        }
    }
}
